// Helper to centralize lead pricing logic
// Counties => €30 per lead
// Eircodes => €40 per lead
export function getLeadPrice(coverageType, countyCount = 0) {
    if (coverageType === 'counties') return 30;
    return 40;
}

export default getLeadPrice;
